<template>
  <v-dialog v-model="uploadingDialog" width="initial" persistent>
    <div class="overlay-content">
      <h4 class="mb-3">
        処理中です。戻るや画面更新やブラウザ閉じる操作を行わないでください。
      </h4>
      <div>
        <v-progress-circular
            v-if="loading === 'uploading'"
            size="22"
            indeterminate
            color="primary"
        ></v-progress-circular>
        <v-icon v-if="loading !== 'uploading'" color="green"
        >mdi-check-circle</v-icon
        >
        <span>アップロード: {{ uploadedFilesNum }}/{{ uploadFilesNum }}ファイル</span>
      </div>
      <div v-if="loading === 'completing'">
        <v-progress-circular
            size="22"
            indeterminate
            color="primary"
        ></v-progress-circular>
        <v-icon v-if="loading === 'done'" color="green"
        >mdi-check-circle</v-icon
        >
        <span>処理中</span>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "UploadProgressDialog",
  props: ['uploadingDialog', 'loading', 'uploadedFilesNum', 'uploadFilesNum']
}
</script>

<style scoped>

</style>
